export default __webpack_public_path__ + "static/media/Orenco_Corporate_Logo.6aa8fd2b.svg";